import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Avatar
} from '@mui/material';
import {
  QrCodeScanner as QrCodeScannerIcon,
  ChevronRight as ChevronRightIcon
} from '@mui/icons-material';

const QRScannerWidget = ({ onClick }) => {
  return (
    <Card 
      elevation={3} 
      sx={{ 
        aspectRatio: '1',
        cursor: 'pointer',
        transition: 'all 0.3s',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        '&:hover': {
          elevation: 6,
          transform: 'translateY(-4px)'
        }
      }}
      onClick={onClick}
    >
      <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="body2" fontWeight="bold" color="white" sx={{ fontSize: '0.85rem' }}>
            Ordre håndtering
          </Typography>
          <IconButton size="small" sx={{ color: 'white', p: 0 }}>
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ textAlign: 'center', py: 0.5, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Avatar
            sx={{
              width: 30,
              height: 30,
              margin: '0 auto 8px',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              border: '2px solid rgba(255, 255, 255, 0.3)'
            }}
          >
            <QrCodeScannerIcon sx={{ fontSize: 30, color: 'white' }} />
          </Avatar>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.95)', fontWeight: 500, fontSize: '0.8rem' }}>
            Skann QR-kode
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.8)', mt: 0.5, display: 'block', fontSize: '0.7rem' }}>
            Finn og oppdater ordrer
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default QRScannerWidget;
